export const API_VERSION = '2.0.0';

export default {
  API_VERSION,
};



// WEBPACK FOOTER //
// ./src/config.js